var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00032 10.6666C4.89576 10.6666 4.00033 11.5621 4.00033 12.6666C4.00033 13.0348 4.2988 13.3333 4.66699 13.3333H11.3337C11.7018 13.3333 12.0003 13.0348 12.0003 12.6666C12.0003 11.5621 11.1049 10.6666 10.0003 10.6666H6.00032ZM2.66699 12.6666C2.66699 10.8257 4.15938 9.33331 6.00032 9.33331H10.0003C11.8413 9.33331 13.3337 10.8257 13.3337 12.6666C13.3337 13.7712 12.4382 14.6666 11.3337 14.6666H4.66699C3.56242 14.6666 2.66699 13.7712 2.66699 12.6666Z",
    fill: "#714FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00033 2.66665C6.89576 2.66665 6.00033 3.56208 6.00033 4.66665C6.00033 5.77122 6.89576 6.66665 8.00033 6.66665C9.1049 6.66665 10.0003 5.77122 10.0003 4.66665C10.0003 3.56208 9.1049 2.66665 8.00033 2.66665ZM4.66699 4.66665C4.66699 2.8257 6.15938 1.33331 8.00033 1.33331C9.84128 1.33331 11.3337 2.8257 11.3337 4.66665C11.3337 6.5076 9.84128 7.99998 8.00033 7.99998C6.15938 7.99998 4.66699 6.5076 4.66699 4.66665Z",
    fill: "#714FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.c9d2f48a04e57f2afcffd9c4c3b61e98.svg";
export { ForwardRef as ReactComponent };